import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { CommonBlueButton } from 'components/common/buttonsComponents';
import { riseAndFadeIn, fadeInFast } from 'components/common/animations';

export const Wrapper = styled.span`
  display: inline-block;
  position: relative;
`;

export const HighlightedContent = styled.span`
  cursor: pointer;
  background-color: ${(props) => props.color};
`;

export const EasyConnectionSelectionForm = styled.form`
  min-height: 100px;
  width: 248px;
  max-width: 263px;
  background-color: ${colors.baseBackground};
  border: 1px solid ${colors.lightGray6};
  border-radius: 4px;
  position: absolute;
  padding: 16px;
  top: 27px;
  left: ${(props) => `${props.formLeft}px`};
  box-shadow: 0px 20px 35px rgba(0, 0, 0, 0.09);
  z-index: 3;
  display: block;
  ${riseAndFadeIn}

  &:before {
    content: '';
    position: absolute;
    top: -8px;
    left: ${(props) => `${props.arrowLeft}px`};

    height: 15px;
    width: 15px;
    background-color: ${colors.baseBackground};
    border-top: 1px solid ${colors.lightGray6};
    border-left: 1px solid ${colors.lightGray6};
    transform: rotate(45deg);
    z-index: 1;
  }
`;

export const Option = styled.section`
  background: ${colors.blue6};
  border: ${(props) => (props.selected ? `1px solid #6EA6E8` : `1px solid ${colors.blue6}`)};
  box-sizing: border-box;
  border-radius: 4px;
  background-color: ${colors.blue6};
  max-width: 214px;
  align-items: center;
  justify-content: flex-start;
  padding: 14px 16px;
  min-height: 47px;
  margin-bottom: 8px;
  display: grid;
  grid-template-columns: max-content max-content;
  grid-gap: 3px;
  white-space: pre-wrap;

  input {
    margin: 0px 10px 0px 0px !important;
  }

  input[type='radio'] {
    cursor: pointer;
  }

  input[type='text'] {
    border: 1px solid #e1e6f2;
    border-radius: 4px;
    padding: 3px 8px;
    outline: none;
    cursor: auto;
    ${fadeInFast}
  }

  label {
    margin: 0px !important;
    max-width: 160px;
  }
`;

export const InsertButton = styled(CommonBlueButton)`
  margin-top: 12px;
`;
